import styles from './_index.module.scss';

export interface MetadataProps extends React.HTMLAttributes<HTMLDivElement> {
  header: string;
}

const Metadata = ({ children, header }: MetadataProps) => {
  return (
    <div className={styles[`metadata`]}>
      <h3>{header}</h3>
      <ul>{children}</ul>
    </div>
  );
};

export default Metadata;
